// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"282":"turn","325":"magazine","975":"hash"}[chunkId] + ".js?v=" + {"282":"99ecba4f577a35a1fc2a","325":"54d33df13cb1d8d8b205","975":"601e0e33e3f5932f171d"}[chunkId] + "";
};